import { useMutation } from '@tanstack/react-query';

import { queryClient } from '@/lib/react-query/queryClient';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import { scoutClient } from '@/modules/scout-sourcing/scoutClient';

type Payload = {
  jobId: string;
  jobSourcingId: string;
};

export const useAbandonTargetingMutation = () =>
  useMutation<void, Error, Payload>({
    mutationFn: ({ jobId, jobSourcingId }) =>
      scoutClient.abandon(jobId, jobSourcingId),
    onSuccess: (_data, variables) => {
      queryClient.removeQueries({
        queryKey: jobsQueryKeys.scoutSession(variables.jobId),
      });
    },
  });
